import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';

const DEFAULT_TOOLTIP_TEXT = 'Copy to clipboard';

const CopyButton = (props: { text: string, children: any }) => {
    const [tooltipText, setTooltipText] = useState<string>(DEFAULT_TOOLTIP_TEXT);

    const handleCopy = () => {
        navigator.clipboard.writeText(props.text);
        setTooltipText('Copied!');
        setTimeout(() => setTooltipText(DEFAULT_TOOLTIP_TEXT), 3000);
    }

    return (
        <>
            {props.children}
            <Tooltip title={tooltipText} style={{ marginLeft: 8 }}>
                <IconButton onClick={handleCopy}>
                    <ContentCopy />
                </IconButton>
            </Tooltip>
        </>
    )
}

export default CopyButton;